"use client";
import { useState } from "react";
import { Check, CopyAll } from "@mui/icons-material";

import { useStore } from "../../service/mobx";

import ToolTip from "../Tooltip";
import Button from "../Button/Text";

function CopyButton({
  label = "Copy",
  copiedLabel = "Copied",
  tooltip = "Copy",
  notificationText,
  sx,
  ...props
}) {
  const { model, snackbar } = useStore();
  const [copied, setCopied] = useState(false);

  return (
    <ToolTip title={tooltip}>
      <Button
        label={copied ? copiedLabel : label}
        IconStart={copied ? Check : CopyAll}
        sx={{ cursor: "pointer", ...sx }}
        onClick={() => {
          navigator.clipboard.writeText(model.node.modelId ?? model.node.name);

          setCopied(true);
          setTimeout(setCopied, 4e3, false);
          snackbar.notify({ text: notificationText ?? "Copied" });
        }}
        {...props}
      />
    </ToolTip>
  );
}

export default CopyButton;
